import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=6982cd3a"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6982cd3a')) {
      api.createRecord('6982cd3a', component.options)
    } else {
      api.reload('6982cd3a', component.options)
    }
    module.hot.accept("./ExampleComponent.vue?vue&type=template&id=6982cd3a", function () {
      api.rerender('6982cd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExampleComponent.vue"
export default component.exports